import { atom, selector } from 'recoil'

import type {
  ChartWidgetState,
  EngagementChartState,
} from 'Pages/RecipientsOverview/types'

export const emptyStateState = atom<boolean>({
  key: 'recipientsOverview_emptyStateState',
  default: false,
})

export const subscriptionsEmailState = atom<ChartWidgetState>({
  key: 'recipientsOverview_subscriptionsEmailState',
  default: {
    status: 'initial',
    loading: false,
    data: [],
  },
})

export const subscriptionsSmsState = atom<ChartWidgetState>({
  key: 'recipientsOverview_subscriptionsSmsState',
  default: {
    status: 'initial',
    loading: false,
    data: [],
  },
})

export const optoutChartState = atom<ChartWidgetState>({
  key: 'recipientsOverview_optoutChartState',
  default: {
    status: 'initial',
    loading: false,
    data: [],
  },
})

export const engagementChartState = atom<EngagementChartState>({
  key: 'recipientsOverview_engagementChartState',
  default: {
    status: 'initial',
    loading: false,
    upselling: false,
    data: [],
  },
})

//

export const subscriptionsEmailEmptyStateState = selector<boolean>({
  key: 'recipientsOverview_subscriptionsEmailEmptyStateState',
  get: ({ get }) => {
    const es = get(emptyStateState)
    const { status, data } = get(subscriptionsEmailState)
    const sum = data.reduce((acc, curr) => acc + curr.value, 0)

    return es || (status === 'ready' && sum === 0)
  },
})

export const subscriptionsSmsEmptyStateState = selector<boolean>({
  key: 'recipientsOverview_subscriptionsSmsEmptyStateState',
  get: ({ get }) => {
    const es = get(emptyStateState)
    const { status, data } = get(subscriptionsSmsState)
    const sum = data.reduce((acc, curr) => acc + curr.value, 0)

    return es || (status === 'ready' && sum === 0)
  },
})

export const optoutEmptyStateState = selector<boolean>({
  key: 'recipientsOverview_optoutEmptyStateState',
  get: ({ get }) => {
    const es = get(emptyStateState)
    const { status, data } = get(optoutChartState)
    const sum = data.reduce((acc, curr) => acc + curr.value, 0)

    return es || (status === 'ready' && sum === 0)
  },
})
